// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dpns","colBig":"styles_colBig__3uiIq","colSmall":"styles_colSmall__2Dw65","shopifyNameWrapper":"styles_shopifyNameWrapper__iHpvV"};